import {
  FETCH_ALL_COUNTRY,
  FETCH_ALL_COUNTRY_SUCCESS,
  EDIT_COUNTRY,
  DELETE_COUNTRY,
  CREATE_COUNTRY,
  CREATE_COUNTRY_SUCCESS,
  UPDATE_COUNTRY_SUCCESS,
  UPDATE_COUNTRY,
  DELETE_COUNTRY_SUCCESS,
  FETCH_ALL_CONTRY_LANG,
  FETCH_ALL_CONTRY_LANG_SUCCESS,
  EDIT_CONTRY_LANG,
  DELETE_CONTRY_LANG,
  CREATE_CONTRY_LANG,
  CREATE_CONTRY_LANG_SUCCESS,
  UPDATE_CONTRY_LANG_SUCCESS,
  UPDATE_CONTRY_LANG,
  DELETE_CONTRY_LANG_SUCCESS,
  FETCH_ALL_SPECIALITY,
  FETCH_ALL_SPECIALITY_SUCCESS,
  EDIT_SPECIALITY,
  DELETE_SPECIALITY,
  CREATE_SPECIALITY,
  CREATE_SPECIALITY_SUCCESS,
  UPDATE_SPECIALITY_SUCCESS,
  UPDATE_SPECIALITY,
  DELETE_SPECIALITY_SUCCESS,

  FETCH_ALL_CONTENT_TYPES,
  FETCH_ALL_CONTENT_TYPES_SUCCESS,

  FETCH_ALL_HEALTH_PARTNER_TYPES,
  FETCH_ALL_HEALTH_PARTNER_TYPES_SUCCESS,

  FETCH_ALL_ROLES,
  FETCH_ALL_ROLES_SUCCESS,

  FETCH_ALL_FEATURE_TYPES,
  FETCH_ALL_FEATURE_TYPES_SUCCESS,

  FETCH_ALL_LANG,
  FETCH_ALL_LANG_SUCCESS,
  EDIT_LANG,
  DELETE_LANG,
  CREATE_LANG,
  CREATE_LANG_SUCCESS,
  UPDATE_LANG_SUCCESS,
  UPDATE_LANG,
  DELETE_LANG_SUCCESS,

  FETCH_REPORT_CONFIG,
  FETCH_REPORT_CONFIG_SUCCESS,
  DELETE_REPORT_CONFIG,
  DELETE_REPORT_CONFIG_SUCCESS,
  CREATE_REPORT_CONFIG,
  CREATE_REPORT_CONFIG_SUCCESS,
  UPDATE_REPORT_CONFIG,
  UPDATE_REPORT_CONFIG_SUCCESS,

  CREATE_DOCTOR_REPORTS,
  CREATE_DOCTOR_REPORTS_SUCCESS,
  VIEW_DOCTOR_REPORTS,
  VIEW_DOCTOR_REPORTS_SUCCESS,
  VIEW_DOCTOR_REPORTS_CLEAN
} from 'constants/master_data.constants'
import { startLoader } from 'actions/general.action';

export const fetchRolesSuccess = (data) => {
  return {
    type: FETCH_ALL_ROLES_SUCCESS,
    payload: data
  };
};

export const fetchRoles = (page) => {
  return dispatch => {
    dispatch({
      type: FETCH_ALL_ROLES,
      payload: page
    })
    //dispatch(startLoader())
  }
}


export const fetchFeatureTypesSuccess = (data) => {
  return {
    type: FETCH_ALL_FEATURE_TYPES_SUCCESS,
    payload: data
  };
};

export const fetchFeatureTypes = (page) => {
  return dispatch => {
    dispatch({
      type: FETCH_ALL_FEATURE_TYPES,
      payload: page
    })
    //dispatch(startLoader())
  }
}


export const fetchHealthPartnerTypes = (page) => {
  return dispatch => {
    dispatch({
      type: FETCH_ALL_HEALTH_PARTNER_TYPES,
      payload: page
    })
    //dispatch(startLoader())
  }
}

export const fetchHealthPartnerTypesSuccess = (data) => {
  return {
    type: FETCH_ALL_HEALTH_PARTNER_TYPES_SUCCESS,
    payload: data
  };
};

export const fetchContentTypes = (page) => {
  return dispatch => {
    dispatch({
      type: FETCH_ALL_CONTENT_TYPES,
      payload: page
    })
    // dispatch(startLoader())
  }
}

export const fetchContentTypesSuccess = (data) => {
  return {
    type: FETCH_ALL_CONTENT_TYPES_SUCCESS,
    payload: data
  };
};

export const fetchCountries = (page) => {
  return dispatch => {
    dispatch({
      type: FETCH_ALL_COUNTRY,
      payload: page
    })
    //dispatch(startLoader())
  }
}

export const fetchCountriesSuccess = (data) => {
  return {
    type: FETCH_ALL_COUNTRY_SUCCESS,
    payload: data
  };
};

export const deleteCountry = (id) => {
  return {
    type: DELETE_COUNTRY,
    payload: id
  };
};

export const editCountry = (id) => {
  return {
    type: EDIT_COUNTRY,
    payload: id
  };
};

export const createCountry = (payload) => {
  return {
    type: CREATE_COUNTRY,
    payload: payload
  };
};

export const createCountrySuccess = (payload) => {
  return {
    type: CREATE_COUNTRY_SUCCESS,
    payload: payload
  };
};

export const updateCountrySuccess = (data) => {
  return {
    type: UPDATE_COUNTRY_SUCCESS,
    payload: data
  };
};

export const deleteCountrySuccess = (data) => {
  return {
    type: DELETE_COUNTRY_SUCCESS,
    payload: data
  };
};

export const updateCountry = (payload) => {
  return {
    type: UPDATE_COUNTRY,
    payload: payload
  };
};

//country_lang

export const fetchCountryLangs = (page) => {
  return dispatch => {
    dispatch({
      type: FETCH_ALL_CONTRY_LANG,
      payload: page
    })
    dispatch(startLoader())
  }
}

export const fetchCountryLangsSuccess = (data) => {
  return {
    type: FETCH_ALL_CONTRY_LANG_SUCCESS,
    payload: data
  };
};

export const deleteCountryLang = (id) => {
  return {
    type: DELETE_CONTRY_LANG,
    payload: id
  };
};

export const editCountryLang = (id) => {
  return {
    type: EDIT_CONTRY_LANG,
    payload: id
  };
};

export const createCountryLang = (payload) => {
  return {
    type: CREATE_CONTRY_LANG,
    payload: payload
  };
};

export const createCountryLangSuccess = (payload) => {
  return {
    type: CREATE_CONTRY_LANG_SUCCESS,
    payload: payload
  };
};

export const updateCountryLangSuccess = (data) => {
  return {
    type: UPDATE_CONTRY_LANG_SUCCESS,
    payload: data
  };
};

export const deleteCountryLangSuccess = (data) => {
  return {
    type: DELETE_CONTRY_LANG_SUCCESS,
    payload: data
  };
};

export const updateCountryLang = (payload) => {
  return {
    type: UPDATE_CONTRY_LANG,
    payload: payload
  };
};

// specialities
export const fetchSpecialities = (page) => {
  return dispatch => {
    dispatch({
      type: FETCH_ALL_SPECIALITY,
      payload: page
    })
    dispatch(startLoader())
  }
}

export const fetchSpecialitiesSuccess = (data) => {
  return {
    type: FETCH_ALL_SPECIALITY_SUCCESS,
    payload: data
  };
};

export const deleteSpeciality = (id) => {
  return {
    type: DELETE_SPECIALITY,
    payload: id
  };
};

export const editSpeciality = (id) => {
  return {
    type: EDIT_SPECIALITY,
    payload: id
  };
};

export const createSpeciality = (payload) => {
  return {
    type: CREATE_SPECIALITY,
    payload: payload
  };
};

export const createSpecialitySuccess = (payload) => {
  return {
    type: CREATE_SPECIALITY_SUCCESS,
    payload: payload
  };
};

export const updateSpecialitySuccess = (data) => {
  return {
    type: UPDATE_SPECIALITY_SUCCESS,
    payload: data
  };
};

export const deleteSpecialitySuccess = (data) => {
  return {
    type: DELETE_SPECIALITY_SUCCESS,
    payload: data
  };
};

export const updateSpeciality = (payload) => {
  return {
    type: UPDATE_SPECIALITY,
    payload: payload
  };
};

//lang

export const fetchLangs = (page) => {
  return dispatch => {
    dispatch({
      type: FETCH_ALL_LANG,
      payload: page
    })
    dispatch(startLoader())
  }
}

export const fetchLangsSuccess = (data) => {
  return {
    type: FETCH_ALL_LANG_SUCCESS,
    payload: data
  };
};

export const deleteLang = (id) => {
  return {
    type: DELETE_LANG,
    payload: id
  };
};

export const editLang = (id) => {
  return {
    type: EDIT_LANG,
    payload: id
  };
};

export const createLang = (payload) => {
  return {
    type: CREATE_LANG,
    payload: payload
  };
};

export const createLangSuccess = (payload) => {
  return {
    type: CREATE_LANG_SUCCESS,
    payload: payload
  };
};

export const updateLangSuccess = (data) => {
  return {
    type: UPDATE_LANG_SUCCESS,
    payload: data
  };
};

export const deleteLangSuccess = (data) => {
  return {
    type: DELETE_LANG_SUCCESS,
    payload: data
  };
};

export const updateLang = (payload) => {
  return {
    type: UPDATE_LANG,
    payload: payload
  };
};


//config
export const fetchConfig = (page) => {
  return dispatch => {
    dispatch({
      type: FETCH_REPORT_CONFIG,
      payload: page
    })
    dispatch(startLoader())
  }
}

export const fetchConfigSuccess = (data) => {
  return {
    type: FETCH_REPORT_CONFIG_SUCCESS,
    payload: data
  };
};

export const updateConfig = (payload) => {
  return dispatch => {
    dispatch({
      type: UPDATE_REPORT_CONFIG,
      payload: payload
    })
    dispatch(startLoader())
  }
};

export const updateConfigSuccess = (data) => {
  return {
    type: UPDATE_REPORT_CONFIG_SUCCESS,
    payload: data
  };
};

export const sendDoctorReports = (payload) => {
  return dispatch => {
    dispatch({
      type: CREATE_DOCTOR_REPORTS,
      payload: payload
    })
    dispatch(startLoader())
  }
};

export const sendDoctorReportsSuccess = (payload) => {
  return {
    type: CREATE_DOCTOR_REPORTS_SUCCESS,
    payload: payload
  };
};

export const viewDoctorReports = (payload) => {
  return (dispatch) => {
    dispatch({
      type: VIEW_DOCTOR_REPORTS,
      payload: payload,
    });
    dispatch(startLoader());
  };
};

export const viewDoctorReportsSuccess = (payload) => {
  return {
    type: VIEW_DOCTOR_REPORTS_SUCCESS,
    payload: payload,
  };
};

export const viewDoctorReportsClean = () => {
  return {
    type: VIEW_DOCTOR_REPORTS_CLEAN,
  };
};
